import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router, ActivatedRoute } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { AuthenticationService } from '../services/authentication.service';
import { Subscription } from 'rxjs/Subscription';

@Injectable()
export class AuthenticationGuard implements CanActivate {
  _subscriptions: Subscription = new Subscription();

  constructor(public _authService: AuthenticationService,
    private router: Router) {
  }

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    let _next_url: string[] = [];

    next.parent.url.forEach((path) => { _next_url.push(path.path) });
    next.url.forEach((path) => { _next_url.push(path.path) });

    if (this._authService.isLoggedIn()) {
      return this._authService.testLogin().map(
        response => {
          this._authService.setLoggedIn(true, response);
          return true;
        }
      ).catch(
        () => {
          this.router.navigate(['/login']);
          return Observable.of(false);
        }
      );

    } else {
      /**
       * Do not retrieve old session. If gone or refresh, need to sign in again.
       *  
      // Not good. Retrieve Old Session
      this._authService.retrievePreviousSession();
      // Then try to log in
      return this._authService.testLogin().map(
        response => {
          this._authService.setLoggedIn(true, response);
          return true;
        }
      ).catch(
        () => { 
          this.router.navigate(['/login']);
          return Observable.of(false);
        }
      );
      */
      this.router.navigate(['/login']);
      return Observable.of(false);
    }
  }

  /*canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    let _next_url: string[] = [];

    next.parent.url.forEach((path) => { _next_url.push(path.path) });
    next.url.forEach((path) => { _next_url.push(path.path) });

    if (this._authService.isLoggedIn()) {
      this._subscriptions.add(
        this._authService.testLogin().subscribe(
          response => {
            // Still valid. Download the user's state now
            this._authService.setLoggedIn(true, response);
            this.router.navigate(_next_url, { queryParams: next.queryParams });

            this._subscriptions.unsubscribe();
          }
        )
      );
      // All good, continue
      return true;
    } else {
      // Not good. Retrieve Old Session
      this._authService.retrievePreviousSession();
      // Then try to log in
      this._subscriptions.add(
        this._authService.testLogin().subscribe(
          response => {
            // Still valid. Good to go
            this._authService.setLoggedIn(true, response);
            this.router.navigate(_next_url, { queryParams: next.queryParams });

            this._subscriptions.unsubscribe();            
          },
          error => {
            // Invalid creds. Send to log in
            this.router.navigate(['/login']);
          }
        )
      );
    }
    return false;
  }*/
}



// WEBPACK FOOTER //
// C:/Users/orion/Projects/simplicityEngine/valmust/valmustfe/src/app/shared/guards/authentication.guard.ts